import axios from 'axios';
const isProd = window.location.href.includes('localhost') ? false : true;
const client = axios.create({
	baseURL: isProd ? 'https://nanashotel.com' : 'http://localhost:5050',
	withCredentials: true,
});

client.interceptors.request.use((config) => {
	try {
		const mode = window.localStorage.getItem('nanashotel');
		if (mode) {
			config.headers = config.headers || {};
			config.headers['x-nanashotel'] = mode;
		}
		const viewPw = window.sessionStorage.getItem('nanashotel-view');
		if (viewPw) {
			config.headers = config.headers || {};
			config.headers['x-view-password'] = viewPw;
		}
	} catch {}
	return config;
});

export default client;
